module.exports = __webpack_public_path__ + "img/play.84acd22a.png";